module.exports = __webpack_public_path__ + "media/assets/images/landings/iot/iot_logo_big-8a29cf6ef9f055d5f2d79a38184e5938.svg";